import { render, staticRenderFns } from "./qrVcard.vue?vue&type=template&id=0adda78e"
import script from "./qrVcard.vue?vue&type=script&lang=js"
export * from "./qrVcard.vue?vue&type=script&lang=js"
import style0 from "./qrVcard.vue?vue&type=style&index=0&id=0adda78e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports